import React from 'react';
import NutritionApp from '../PreemieNutrition/NutritionApp';
import { NICU_NUTRITION_VARIANT } from '../PreemieNutrition/variants';

/**
 * "הזנה בטיפול נמרץ ילדים" — same calculator as תזונת פגים, different config.
 *
 * All behaviour lives in `apps/PreemieNutrition/NutritionApp.tsx`; this app only
 * binds the `NICU_NUTRITION` variant so it reads/writes its own AppConfig rows.
 */
const NicuNutritionApp: React.FC<{ hospital?: string }> = ({ hospital }) => (
    <NutritionApp hospital={hospital} variant={NICU_NUTRITION_VARIANT} />
);

export default NicuNutritionApp;
